import styled from 'styled-components/native';

import { PADDING_BOTTOM, PADDING_TOP } from '../LoginRegisterTextField/constants';
import { IconButton } from '../../Buttons';

export const StyledIconButton = styled(IconButton)`
  marginBottom: ${PADDING_BOTTOM}px;
  marginTop: ${PADDING_TOP}px;
`;
